import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of, from } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiInit } from '../utils/api-init';
import { CurrentWhiteLabelApplication } from '../utils/current-white-label-application';
import { ProjectStore } from '../pages/project/project.store';

export function projectResolver(
  route: ActivatedRouteSnapshot
): Observable<null> {
  const projectStore = inject(ProjectStore);
  const apiInit = inject(ApiInit);
  const app = inject(CurrentWhiteLabelApplication);

  const slug = app.isProjectApp()
    ? app.getProjectAppSlug()
    : route.paramMap.get('slug');

  if (!slug) return of(null);

  return from(
    apiInit.watch(async () => {
      const current = projectStore.project();
      if (current?.slug === slug) {
        await projectStore.loadProject(slug, true);
      } else {
        await projectStore.loadProject(slug);
      }
    })
  ).pipe(catchError(() => of(null)));
}
